import React, { useEffect } from "react";
import "./About.css";
import "@fontsource/source-sans-pro";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MainBanner from "./components/MainBanner/MainBanner";
import NewImg2 from "./assets/images/NewImg2.jpeg";
import Banner from "./components/Banner/Banner";
import List from "./components/List/List";
import { Helmet } from "react-helmet-async";

const About = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About ISKCON Vijayawada – Our Purpose, People & Devotion</title>
        <meta
          name="description"
          content="Learn about ISKCON Vijayawada’s vision, leadership, and how we promote Krishna consciousness through seva, devotion, and community spiritual programs."
        />
        <meta
          name="keywords"
          content="About ISKCON Vijayawada, Krishna temple vision, ISKCON Andhra Pradesh, spiritual mission"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="About ISKCON Vijayawada – Our Purpose, People & Devotion"
        />
        <meta
          property="og:description"
          content="Learn about ISKCON Vijayawada’s vision, leadership, and how we promote Krishna consciousness through seva, devotion, and community spiritual programs."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/about"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About ISKCON Vijayawada – Our Purpose, People & Devotion"
        />
        <meta
          name="twitter:description"
          content="Learn about ISKCON Vijayawada’s vision, leadership, and how we promote Krishna consciousness through seva, devotion, and community spiritual programs. "
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.iskconvijayawada.org/about" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About ISKCON Vijayawada",
            description:
              "Learn about ISKCON Vijayawada, its mission, history, and activities in spreading Krishna consciousness in the Vijayawada region.",
            url: "https://www.iskconvijayawada.org/about",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.iskconvijayawada.org",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "About",
                  item: "https://www.iskconvijayawada.org/about",
                },
              ],
            },
            mainEntity: {
              "@type": "Organization",
              name: "ISKCON Vijayawada",
              alternateName:
                "International Society for Krishna Consciousness, Vijayawada",
              description:
                "ISKCON Vijayawada is a center for practicing bhakti-yoga and spreading Krishna consciousness in the Vijayawada region of Andhra Pradesh, India.",
              url: "https://www.iskconvijayawada.org",
              logo: "https://www.iskconvijayawada.org/images/logo.png",
              foundingDate: "1970",
              founder: {
                "@type": "Person",
                name: "A.C. Bhaktivedanta Swami Prabhupada",
              },
              address: {
                "@type": "PostalAddress",
                streetAddress: "ISKCON Krishna Temple, NH-16 Service Road",
                addressLocality: "Vijayawada",
                addressRegion: "Andhra Pradesh",
                postalCode: "520008",
                addressCountry: "IN",
              },
              telephone: "+91-8006880038",
              sameAs: [
                "https://www.facebook.com/iskconvijayawada",
                "https://www.youtube.com/iskconvijayawada",
                "https://www.instagram.com/iskconvijayawada",
              ],
            },
          })}
        </script>
      </Helmet>
      <Header />
      <div className="about-page md:mt-8">
        <MainBanner />
        <div className="d-flex justify-content-center p-4 rounded-xl md:h-[100vh] md:m-9">
          <img
            loading="lazy"
            src={NewImg2}
            alt="ISKCON origin & story"
            className="about rounded-xl"
          />
        </div>
        <Banner />
        <List />
      </div>
      <Footer />
    </>
  );
};




// "ssa"
export default About;
